import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/**
 * Renders modal dialog (popover).
 */
export const Dialog = ({ children }: Props) => {
  return (
    <div className="dialog">
      <div className="overlay" />
      <div className="content">{children}</div>
    </div>
  );
};
